import { Injectable } from '@angular/core';
import { FikoYTIstekKok } from '@/src/service/modules/fikoyt-istek-kok/fikoyt.istek.makinesi.service';

@Injectable({ providedIn: 'root' })
export class FikoYTRequestService {

  /** MongoDB aggregate sorgusu */
  async aggregate<T = any>(komut: string, pipeline: any[]): Promise<T[]> {
    const istek = new FikoYTIstekKok({ metod: 'POST', komut });
    istek.parametreler = { aggregate: pipeline };
    await istek.isteSync();
    return (istek.cevap?.sonuc || []) as T[];
  }

  /** Dokuman guncelleme */
  async guncelle(komut: string, filter: any, veri: any, eksenel: any = {}): Promise<any> {
    const istek = new FikoYTIstekKok({ metod: 'POST', komut });
    const fd = new FormData();
    fd.append('req_body', JSON.stringify({ filter, veri, ...eksenel }));
    istek.parametreler = fd;
    await istek.isteSync();
    return istek.cevap?.sonuc;
  }

  /** Dokuman silme */
  async sil(komut: string, filter: any): Promise<any> {
    const istek = new FikoYTIstekKok({ metod: 'POST', komut });
    const fd = new FormData();
    fd.append('req_body', JSON.stringify(filter));
    istek.parametreler = fd;
    await istek.isteSync();
    return istek.cevap?.sonuc;
  }

  /** Yeni dokuman ekleme */
  async ekle<T = any>(komut: string, veri: any): Promise<T> {
    const istek = new FikoYTIstekKok({ metod: 'POST', komut });
    const fd = new FormData();
    fd.append('req_body', JSON.stringify(veri));
    istek.parametreler = fd;
    await istek.isteSync();
    return istek.cevap?.sonuc as T;
  }

  /** Sayfali aggregate sorgusu ($facet ile) */
  async sayfaliSorgu<T = any>(komut: string, pipeline: any[], sayfa: number, limit: number): Promise<{ toplam: number; liste: T[] }> {
    const sonuc = await this.aggregate(komut, [
      ...pipeline,
      {
        $facet: {
          toplam: [{ $count: 'sayi' }],
          liste: [{ $skip: (sayfa - 1) * limit }, { $limit: limit }],
        },
      },
    ]);
    const facet = sonuc?.[0] as any;
    return {
      toplam: facet?.toplam?.[0]?.sayi || 0,
      liste: (facet?.liste || []) as T[],
    };
  }
}
